import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;
const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;
/* animation style */
export const AnimationContainer = styled.div<{ isShowElement: boolean }>`
  visibility: ${({ isShowElement }) => (isShowElement ? "visible" : "hidden")};
  animation: ${({ isShowElement }) => (isShowElement ? fadeIn : fadeOut)} 0.15s ease-in;
  transition: all 0.15s ease-in;
`;
